import { useEffect } from 'react'
import { ArticlePage, PageHead, CreditTest } from '@/components'
import api from '@/lib/api'

const PressCenter = ({ article }) => {
    const handleView = async () => {
        await api.articles.view(article.slug)()
    }

    useEffect(() => {
        handleView()
    }, [])

    return (
        <>
            <PageHead meta={article.seo_meta}/>
            <ArticlePage
                title={article.title}
                date={article.publication_date}
                views={article.views}
                img={article.preview}
                content={article.content}
            />
            {(article.id == 103) && <CreditTest />}
        </>
    )
}

PressCenter.getInitialProps = async ({ api, query }) => {
    const article = await api.articles.item(query.articleSlug)()

    return { article: article.data }
}

export default PressCenter
